import LdsAudienceAffirmationModal from "../../components/LdsModal/LdsAudienceAffirmationModal.jsx";
import { useContext } from "react";
import LdsLink from "../LdsLink/index.jsx";
import LdsButton from "../LdsButton/index.jsx";
import { LdsModalContext } from "./LdsModalProvider.jsx";
export default function HcpModal() {
  const { setAudienceAffirmationCookie } = useContext(LdsModalContext);
  return (
    <LdsAudienceAffirmationModal
      modalId="hcpModal"
      heading="For Healthcare Professionals"
    >
      <p className="text-center">
        The information contained in amyvidtraining.lilly.com is intended for
        healthcare professionals in the United States only. If you are a US
        healthcare professional, click the "Continue" button below.
      </p>
      <p className="text-center">
        <strong>
          Yes, I am a US healthcare professional and would like to continue
        </strong>
      </p>
      <div className="text-center">
        <div className="mx-auto col-12 col-md-6">
          <LdsLink
            href="https://www.lilly.com/index?redirect-referrer=https%3A%2F%2Famyvidtraining.lilly.com%2F"
            mode="button"
            style={{ marginRight: "1rem" }}
            className="lds-button white-button"
          >
            Go Back
          </LdsLink>
          <LdsButton
            onClick={setAudienceAffirmationCookie}
            className="blue-button"
          >
            Continue
          </LdsButton>
        </div>
      </div>
    </LdsAudienceAffirmationModal>
  );
}
